<template>
  <SubNavCardVue :buttons="buttons" />
</template>

<script>
import SubNavCardVue from "../../components/cards/SubNavCard.vue";

export default {
  components: { SubNavCardVue },
  data() {
    return {
      buttons: [
        {
          label: "Scan / Dépannage",
          icon: "bi bi-upc-scan",
          route: "troubleshooting-index",
        },
      ],
    };
  },
};
</script>
